const DEFAULT_WORKER_BASE = process.env.REACT_APP_R2_WORKER_BASE || 'https://forza.matteo-fbr.workers.dev';

export const resolveImageKitUrl = (path, urlEndpoint) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const base = (urlEndpoint || '').replace(/\/$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return normalizedPath ? `${base}/${normalizedPath}` : base;
};

export const getMediaUrl = (key, workerBase = DEFAULT_WORKER_BASE) => {
  if (!key) return '';
  if (/^https?:\/\//i.test(key)) {
    return key;
  }
  const base = (workerBase || '').replace(/\/$/, '');
  const normalized = key.replace(/^\/+/, '');
  return normalized ? `${base}/${normalized}` : base;
};
